/* Lauren — recently viewed + wishlist (localStorage-only, no API) */

const RV_KEY = 'lauren_recently_viewed';
const WL_KEY = 'lauren_wishlist';
const RV_LIMIT = 12;

/* ---------- Recently viewed ---------- */
const recentlyViewed = {
  get() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch { return []; }
  },
  add(handle) {
    if (!handle) return;
    let h = this.get().filter((x) => x !== handle);
    h.unshift(handle);
    h = h.slice(0, RV_LIMIT);
    localStorage.setItem(RV_KEY, JSON.stringify(h));
  },
};

/* ---------- Wishlist ---------- */
const wishlist = {
  get() {
    try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch { return []; }
  },
  has(handle) { return this.get().includes(handle); },
  toggle(handle) {
    let list = this.get();
    if (list.includes(handle)) {
      list = list.filter((x) => x !== handle);
    } else {
      list.unshift(handle);
    }
    localStorage.setItem(WL_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('lauren:wishlist:change', { detail: { count: list.length } }));
    return list.includes(handle);
  },
  count() { return this.get().length; },
};

window.LaurenWishlist = wishlist;
window.LaurenRecentlyViewed = recentlyViewed;

/* ---------- Track recently viewed when on a product page ---------- */
(function trackPDP() {
  const m = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (m && m[1]) recentlyViewed.add(m[1]);
})();

/* ---------- Render recently viewed carousel ---------- */
async function renderRecentlyViewed(container) {
  const handles = recentlyViewed.get();
  if (handles.length === 0) {
    container.closest('[data-rv-section]')?.setAttribute('hidden', '');
    return;
  }

  const currentHandle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  const filtered = handles.filter((h) => h !== currentHandle).slice(0, 8);
  if (filtered.length === 0) {
    container.closest('[data-rv-section]')?.setAttribute('hidden', '');
    return;
  }

  const products = await Promise.all(
    filtered.map((h) =>
      fetch(`/products/${h}.js`)
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null)
    )
  );

  const cards = products.filter(Boolean).map(buildCard).join('');
  if (!cards) {
    container.closest('[data-rv-section]')?.setAttribute('hidden', '');
    return;
  }
  container.innerHTML = cards;
  // Wire wishlist hearts on the freshly rendered cards
  hydrateWishlistHearts(container);
}

function buildCard(p) {
  const img = p.featured_image ? p.featured_image.replace(/^https?:/, '') : '';
  const price = formatMoney(p.price);
  const compare = p.compare_at_price && p.compare_at_price > p.price ? p.compare_at_price : null;
  const compareHtml = compare
    ? `<s class="lrv-card__compare">${formatMoney(compare)}</s>`
    : '';
  const savePct = compare ? Math.round(((compare - p.price) * 100) / compare) : null;
  const badgeHtml = savePct
    ? `<span class="lrv-card__badge">Save ${savePct}%</span>`
    : '';
  const isWished = wishlist.has(p.handle);

  return `
    <a href="${p.url}" class="lrv-card" data-handle="${p.handle}">
      <div class="lrv-card__media">
        ${img ? `<img src="${img}" alt="${escapeHtml(p.title)}" loading="lazy" width="400" height="400">` : '<div class="lrv-card__placeholder"></div>'}
        ${badgeHtml}
        <button type="button" class="lrv-card__heart${isWished ? ' is-active' : ''}" data-wishlist-toggle="${p.handle}" aria-label="Toggle wishlist" title="Save to wishlist">
          <svg viewBox="0 0 24 24" fill="${isWished ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="1.6" width="18" height="18"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
        </button>
      </div>
      <div class="lrv-card__body">
        <h3 class="lrv-card__title">${escapeHtml(p.title)}</h3>
        <div class="lrv-card__price">
          ${compareHtml}
          <span class="lrv-card__sale">${price}</span>
        </div>
      </div>
    </a>
  `;
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
}

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

/* ---------- Wishlist hearts on cards (hydrate any heart in the doc) ---------- */
function hydrateWishlistHearts(root = document) {
  root.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
    if (btn.dataset.lrvHydrated) return;
    btn.dataset.lrvHydrated = '1';
    const handle = btn.dataset.wishlistToggle;
    if (wishlist.has(handle)) btn.classList.add('is-active');
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isOn = wishlist.toggle(handle);
      btn.classList.toggle('is-active', isOn);
      const svg = btn.querySelector('svg');
      if (svg) svg.setAttribute('fill', isOn ? 'currentColor' : 'none');
    });
  });
}

/* ---------- Update wishlist count badge in header ---------- */
function updateWishlistBadge() {
  const badge = document.querySelector('[data-wishlist-count]');
  if (!badge) return;
  const c = wishlist.count();
  badge.textContent = c;
  badge.classList.toggle('is-empty', c === 0);
}

/* ---------- Init ---------- */
document.addEventListener('DOMContentLoaded', () => {
  hydrateWishlistHearts();
  updateWishlistBadge();
  document.querySelectorAll('[data-recently-viewed-target]').forEach(renderRecentlyViewed);
});

document.addEventListener('lauren:wishlist:change', updateWishlistBadge);
